import VDialogPW from '@voly/ui-components/src/v2/VDialogPW';
import { ReactElement, ReactNode, useState } from 'react';
import { translate } from 'src/app/project/features/translate/translate';

type TBulkEditDialogProps = {
  title: string;
  body: ReactNode;
  canSave: boolean;
  size?: 'sm' | 'md' | 'lg';
  onClose: () => void;
  onSave: () => Promise<void>;
};

const BulkEditDialog = ({
  title,
  body,
  canSave,
  size,
  onClose,
  onSave,
}: TBulkEditDialogProps): ReactElement => {
  const [isSaving, setIsSaving] = useState(false);

  const handleOpenChange = (details: { open: boolean }): void => {
    if (!details.open) {
      onClose();
    }
  };

  const handleSave = async (): Promise<void> => {
    setIsSaving(true);

    try {
      await onSave();
    } catch {
      setIsSaving(false);

      return;
    }

    onClose();
  };

  return (
    <VDialogPW
      open
      size={size}
      scrollBehavior="inside"
      title={title}
      body={body}
      loading={isSaving}
      saveButtonDisabled={!canSave}
      saveBtnText={translate('save')}
      cancelBtnText={translate('cancel')}
      onOpenChange={handleOpenChange}
      onOk={handleSave}
      onCancel={onClose}
    />
  );
};

export default BulkEditDialog;
